import { IAppState } from '../../../AppModulesWrapper';

export const selectIsAgencyBalanceVisible = (state: IAppState): boolean => {
  return !!state.servicePickerWidget.user.showAgencyBalance;
};
